import { ValidatorFn } from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";

export const phone: ValidatorFn = (value: string): boolean => {
  if (window.mangasPortal === 'ee') {
    return !helpers.req(value) || /^\+\d{10,11}$/.test(value);
  }
  return !helpers.req(value) || /^\+\d{11}$/.test(value);
}

export const fullName: ValidatorFn = (value: string): boolean =>
  !helpers.req(value) ||
  /^([a-z\u00c0-\u017e])+(\s([a-z\u00c0-\u017e-])+)+$/i.test(value);

export const equal =
  (expectedValue: unknown): ValidatorFn =>
  (value: string): boolean =>
    !helpers.req(value) || value === expectedValue;

export const noop = () => true;

export const timeRange = (from: string, to: string) => {
  const getMinutes = (time: string): number => {
    const [hourString, minuteString] = time.split(":");
    const minutes =
      Number.parseInt(hourString) * 60 + Number.parseInt(minuteString);

    return minutes;
  };

  const fromMinutes = getMinutes(from);
  const toMinutes = getMinutes(to);

  return helpers.withParams({ from, to }, (value: string) => {
    if (!helpers.req(value)) {
      return true;
    }

    const valueMinutes = getMinutes(value);

    return valueMinutes >= fromMinutes && valueMinutes <= toMinutes;
  });
};
